import React, { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

interface ReleaseBadgeProps {
  children: ReactNode;
}

export const ReleaseBadge = ({ children }: ReleaseBadgeProps) => {
  return (
    <Box display="flex">
      {children}
      <Box position="relative" width={60}>
        <Chip
          label="NOVO"
          color="secondary"
          size="small"
          sx={(theme) => ({
            position: 'absolute',
            top: -8,
            height: 17,
            left: theme.spacing(0.5),
            '& .MuiChip-label': {
              display: 'flex',
              padding: '1px 8px',
              fontSize: '0.81rem',
              fontWeight: 800,
            },
          })}
        />
      </Box>
    </Box>
  );
};
